export type CurrentEnv = 'local' | 'stage' | 'prod';

/**
 * Get the current environment based on the hostname (checks the URL).
 * @returns {'local'|'stage'|'prod'} The current environment.
 */
export const getEnv = (): CurrentEnv => {
  const hostname = window.location.hostname;
  if (hostname.includes('pay-by-link.cloudbeds-stage.com')) return 'stage';
  if (hostname.includes('pay-by-link.cloudbeds.com')) return 'prod';
  if (hostname.includes('pay-by-link.cloudbeds-local.com')) return 'local';
  return 'local';
};

export const isProd = (): boolean => getEnv() === 'prod';
export const isStage = (): boolean => getEnv() === 'stage';
export const isLocal = (): boolean => getEnv() === 'local';

const currentEnv = getEnv();

const launchdarklyKeyMap: Record<CurrentEnv, string> = {
  local: '63619de61f265e0d5a4baacd',
  prod: '63619e1f0672c00c060fe7bc',
  stage: '63619e1610a3d90b9775aecb',
};

const LAUNCH_DARKLY_API_KEY = launchdarklyKeyMap[currentEnv];

/**
 * Application-wide configuration object for payment-sdk.
 */
export const AppConfig = {
  /**
   * Contains LaunchDarkly API key for feature flag management.
   */
  launchDarklyKey: LAUNCH_DARKLY_API_KEY,
  /**
   * What deployment environment the app is running in: local, prod, or stage
   */
  currentEnv,
};
